import reduceReducers from 'reduce-reducers';

//Siblings reducers
import staffReducer from './staffReducer';

export default reduceReducers(staffReducer);
